import * as utils from "@twiage/utils";
import type { PromiseAction } from "@twiage/utils/types/PromiseAction";
import { reactive } from "vue";

export const useTrackedPromise = <Input, Output>({
  action,
  asyncFunction,
  onFulfilled,
  onRejected,
  onSettled,
}: {
  action: PromiseAction;
  asyncFunction: (input: Input) => Promise<Output> | never;
  onFulfilled?: (input: Output) => void;
  onRejected?: (input: unknown) => void;
  onSettled?: () => void;
}) => {
  const trackedPromise = utils.makeTrackedPromise<Input, Output>({
    action,
    asyncFunction,
    onFulfilled,
    onRejected,
    onSettled,
  });

  return reactive(trackedPromise);
};
